<template>
<div>
	<header class="mdc-top-app-bar top-app-bar top-header">
		<div class="mdc-top-app-bar__row">
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
				<!-- <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle"
					aria-label="Open navigation menu">menu</button>-->
				<span class="mdc-top-app-bar__title t-subtitle4 pdl-12 cursor-pointer">{{ brandName}}</span>
			</section>
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
				<!-- <div class="profile d-flex align-items-center mgr-24"><img src="images/avtar.svg"
						class="w-32 h-32 circle mgr-16" alt="">
					<div class="t-body2 t-color-white">USER ID</div>
				</div> -->
				<div class=" t-body2 t-color-white pdr-18 cursor-pointer">
					<router-link tabindex="0" to="/login" class="t-body2 t-color-appbarText">{{$t('289')}}</router-link>
				</div>
				<!-- <div class=" t-body2 t-color-appbarText pdr-18 cursor-pointer">LOGOUT</div> -->
			</section>
		</div>
	</header>
	<div class="d-flex h-full flex-column">
		<main class="main-wrapper full flex-grow-1 scroll-y">

			<div class="container container--narrow pdt-50 ">
				<div class="border b-radius4 pda-36">
					<div class="t-headline10 font-b ">{{$t('1224')}}</div>
					<div class="mgt-24 bg-shadow2 h-2"></div>
				<div class="t-body1 t-color-bodyGrayA font-r pdt-24 t-line-h-26 l-spacing48" v-html="htmlPrivacypolicy">
				</div>
				</div>
				<div class="t-body3 t-color-bodyGrayA font-r mgt-24 pdr-24 ">
					{{$t('179')}} : {{privacyDate}}
					<!-- {{$t('793',{'str1':year,'str2':month,'str3':day})}} -->
				</div>

				<div class="mgt-50 mgb-50 ">
					<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4" @click="next()" @keypress="next()" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('3315')}}</span>
					</button>
					<!-- <button class="mdc-button btn-white mgr-8 mgl-8 t-color-secondaryBtnText  t-body2"  type="button" @click="next()">
                    {{$t('3315')}}
                </button> -->
					
				</div>
			</div>
		</main>
	</div>
</div>
</template>

<script>
/**
 * 개인정보 취급방침 컴포넌트(Privacy Policy Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import joinApi from '@/api/joinApi.js'
import {joinMixin} from '@/mixins/join.js'

export default {
	components: {
		TopAppBar
	},
	data() {
		return {
			// title: '개인정보 보호정책',
			title: this.$t('1224'),
			htmlPrivacypolicy: null,
			year:'',
			month:'',
			day:'',
			brandName: localStorage.getItem("brandName") || 'BRAND NAME',
			memberName: localStorage.getItem("memberName"),
			privacyDate:''
		}
	},
	mixins: [topAppBarMixin, joinMixin],
	methods :{
		next(){
			this.$router.go(-1);
		}
	},
	mounted() {
		this.setTopAppBarCloseOnly(this.title)

		// 약관정보 API 호출(call api Privacy Policy )
		joinApi.terms().then((response) => {
			// console.log(response.data.data)
			const termsUrl = response.data.data.TERMS_OF_SERVICE;
			const privacyUrl = response.data.data.PRIVACY_STATEMENT;

			joinApi.policyContents(privacyUrl,'text').then((response) => {
				this.htmlPrivacypolicy = response.data
			})            
		}).catch((err) => {
		})
		let params = {type:'PRIVACY_STATEMENT'};
		joinApi.termsDate(params).then((response) => {
			if(response.data.data){
				this.privacyDate = this.$moment(response.data.data).format("L")
				this.year = this.$moment(response.data.data).format("Y");
				this.month = this.$moment(response.data.data).format("MM");
				this.day = this.$moment(response.data.data).format("DD");
			}
		}).catch((err) => { console.log('err=>',err)})
	}

}
</script>